import { render, staticRenderFns } from "./CmsForm.vue?vue&type=template&id=00138aaf&scoped=true&"
import script from "./CmsForm.vue?vue&type=script&lang=js&"
export * from "./CmsForm.vue?vue&type=script&lang=js&"
import style0 from "./CmsForm.vue?vue&type=style&index=0&id=00138aaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00138aaf",
  null
  
)

export default component.exports